import { Directive, OnInit, TemplateRef, ViewContainerRef, OnDestroy, ChangeDetectorRef, inject, input } from '@angular/core';

import { Store } from '@ngrx/store';
import { AppSelectors } from 'projects/semeris/src/store/app/app.selectors';
import { RootState } from 'projects/semeris/src/store/root-state.model';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Directive({
  standalone: true,
  selector: '[hasAsset]',
})
export class HasAssetDirective implements OnInit, OnDestroy {
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly store = inject<Store<RootState>>(Store);

  public readonly hasAssetDisabled = input<boolean>();

  private readonly completed$ = new Subject();

  public ngOnInit() {
    if (!this.hasAssetDisabled()) {
      this.store
        .select(AppSelectors.selectedAssetShortNames)
        .pipe(takeUntil(this.completed$), distinctUntilChanged())
        .subscribe((assetShortName) => {
          this.viewContainer.clear();

          if (assetShortName?.length) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          }

          this.changeDetectorRef.markForCheck();
        });
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.changeDetectorRef.markForCheck();
    }
  }

  public ngOnDestroy(): void {
    this.completed$.next(undefined);
    this.completed$.complete();
  }
}
